import { render, staticRenderFns } from "./ConfirmationColumn.vue?vue&type=template&id=24396812&scoped=true&"
import script from "./ConfirmationColumn.vue?vue&type=script&lang=js&"
export * from "./ConfirmationColumn.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationColumn.vue?vue&type=style&index=0&id=24396812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24396812",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow,VSpacer})
